<template>
  <fragment>
    <AppBody title="Termos" subtitle="Listagem de Termos" :actions="actions">
      <v-form @submit.prevent="$termos.filtroTermos()" class="search-forms">
        <v-row class="d-flex mb-5">
          <v-col cols="3">
            <label class="input-labels"> Descrição </label>
            <v-text-field
              solo
              placeholder="Insira a descrição"
              v-model="$termos.filter.descricao"
              type="text"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Tipo Pessoa </label>
            <v-select
              height="48"
              :items="$termos.tipo_pessoa"
              item-text="value"
              item-value="key"
              dense
              solo
              class="textinput"
              v-model="$termos.filter.tipo_pessoa"
              placeholder="Selecione o status"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clearable
              @click:clear="clearFilterFields('tipo_pessoa')"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Status </label>
            <v-select
              height="48"
              :items="$termos.status"
              item-text="value"
              item-value="key"
              dense
              solo
              class="textinput"
              v-model="$termos.filter.status"
              placeholder="Selecione o status"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clearable
              @click:clear="clearFilterFields('status')"
            ></v-select>
          </v-col>
          <v-col cols="2" align-self="end" class="ml-auto">
            <v-btn
              height="48"
              class="button btn-size btn-border"
              type="submit"
              :loading="$termos.loading_button"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          class="table-body"
          no-data-text="Não há registro de termos."
          loading-text="Buscando informações..."
          :headers="headers"
          :loading="$termos.loading_termos"
          :items="tableTermos"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: 'Termos por página:',
          }"
        >
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="openModal('modal-body-termos', 'edit', item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-form>
    </AppBody>
    <TermosAdd />
  </fragment>
</template>

<script>
export default {
  name: "Termos",
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    TermosAdd: () => import("@/components/termos/termos-modal-add.vue"),
  },
  metaInfo: {
    title: "Termos | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Termos | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      // header da tabela
      actions: [
        {
          name: "Novo Termo",
          action: () => this.openModal("modal-body-termos", "new", null),
        },
      ],
      headers: [
        {
          text: "Descrição",
          align: "center",
          sortable: false,
          value: "descricao",
          width: 160,
        },
        {
          text: "Tipo de Pessoa",
          align: "center",
          sortable: true,
          value: "tipo",
        },
        {
          text: "Data de inclusão",
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Data de alteração",
          align: "center",
          sortable: true,
          value: "alt_dthr",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          fixed: true,
          value: "actions",
        },
      ],
    };
  },
  computed: {
    tableTermos() {
      this.$termos.termos.forEach(item => {
        item.tipo = item.tipo == "PDV" ? "PONTO DE VENDA" : "LOJA";
        item.ins_dthr = item.ins_dthr
          ? this.$config.convertDataBR(item.ins_dthr.split(" ")[0]) +
            " " +
            item.ins_dthr.split(" ")[1]
          : "-";
        item.alt_dthr = item.alt_dthr
          ? this.$config.convertDataBR(item.alt_dthr.split(" ")[0]) +
            " " +
            item.alt_dthr.split(" ")[1].substring(0, 8)
          : "-";
      });

      return this.$termos.termos;
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
  },
  methods: {
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$termos.filter.status = "";
          break;
        case "tipo_pessoa":
          this.$termos.filter.tipo_pessoa = "";
          break;
        case "descricao":
          this.$termos.filter.descricao = "";
          break;
        default:
          break;
      }
    },

    openModal(name, type, data) {
      this.$termos.termosAddEdit = type;
      if (type == "edit") {
        this.$termos.cadastro.idtermo = data.idtermo;
        this.$termos.cadastro.descricao = data.descricao;
        this.$termos.cadastro.status = data.status;
        this.$termos.cadastro.tipo_pessoa = data.tipo;
        this.$termos.cadastro.texto = data.texto;
      }
      this.$termos.add_termos = true;
    },
  },
  mounted() {
    this.$termos.getTermos();
  },
  destroyed() {
    this.$termos.limpaFiltros();
  },
};
</script>

<style scoped>
.termos-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0;
  align-items: center;
  border-width: 0;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
